"use client"
import { getAllBlogs } from "@/API/response";
import { fetchingStart, getCandidateSuccess } from "@/GlobalRedux/GetCareerDetails";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ApplicantCards from "./ApplicantCard";
export const ApplicantCard = () => {
  const dispatch = useDispatch();
  const [selectedDepartment, setSelectedDepartment] = useState("");
  const getCandidateDatails = async () => {
    try {
      const route = '/career/get'
      dispatch(fetchingStart())
      const response = await getAllBlogs(route);
      // console.log("response", response)
      dispatch(getCandidateSuccess(response?.data));
    } catch (error) {
      console.log("error", error.response.data);
    }
  };
  const { getDetail, isloader } = useSelector((state) => state.candidateDetail);
  // console.log("get candicate details ===>>>>", getDetail)
  const filteredCandidates = selectedDepartment
    ? getDetail.filter((data) => data.department === selectedDepartment)
    : getDetail;
    const sortedApplicant = filteredCandidates?.slice().sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
    // console.log("applicant-->>>>",sortedApplicant)

  

  useEffect(() => {
    getCandidateDatails()
  }, [])
  // "Web Development", "Digital Marketing", "Sales", "Project Management","Accounts & Finance", "Others"
  return (
    <>
     <div className="px-4 md:px-10 py-16 bg-gradient-to-b from-[#020617] via-[#020617] to-[#0f172a]  min-h-screen text-white">
      {/* Header + Filter */}
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row md:items-center md:justify-between gap-6 mb-10">
        <h1 className="text-3xl md:text-5xl font-bold text-white tracking-tight text-center md:text-left">
          Candidate Applications
        </h1>

        <div className="flex flex-col md:flex-row md:items-center gap-4">
          <label className="text-sm md:text-base font-semibold text-gray-300">
            Filter by Department
          </label>
          <select
            value={selectedDepartment}
            onChange={(e) => setSelectedDepartment(e.target.value)}
            className="px-4 py-2 rounded-lg bg-gray-800 border border-gray-600 text-gray-200 focus:outline-none focus:ring-2 focus:ring-blue-500 transition"
          >
            <option value="">All Departments</option>
            <option value="Web Development">Web Development</option>
            <option value="Digital Marketing">Digital Marketing</option>
            <option value="Sales">Sales</option>
            <option value="Project Management">Project Management</option>
            <option value="Accounts & Finance">Accounts & Finance</option>
            <option value="Others">Others</option>
          </select>
        </div>
      </div>

      {/* Selected Department Title */}
      {selectedDepartment && (
        <h2 className="text-xl md:text-2xl font-semibold text-gray-300 mb-8 text-center md:text-left">
          {selectedDepartment} Department
        </h2>
      )}

      {/* Cards / Loader / Empty State */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3  gap-6 max-w-7xl mx-auto">
        {isloader ? (
          <div className="col-span-full flex justify-center items-center h-96">
            <div className="animate-spin rounded-full h-16 w-16 border-b-4 border-blue-500"></div>
          </div>
        ) : sortedApplicant.length === 0 ? (
          <div className="col-span-full flex justify-center items-center h-64">
            <h2 className="text-gray-400 bg-gray-800/50 backdrop-blur-sm p-6 rounded-xl font-semibold text-center shadow-md border border-gray-700">
              No Candidate Applicant Request
            </h2>
          </div>
        ) : (
          sortedApplicant.map((data, index) => (
            <ApplicantCards
              key={index}
              applicantName={data.fullname}
              applicantRole={data.department}
              previousJob={data.previousJob}
              applicantExp={data.experience}
              applicantEmail={data.email}
              applicantPhone={data.mobile}
              applicantLinkedin={data.linkedin}
              applicantDate={new Date(data.createdAt)
                .toLocaleDateString("en-CA")
                .split("-")
                .reverse()
                .join("-")}
              id={data._id}
            />
          ))
        )}
      </div>
    </div>
    </>
  );
};
